import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
  hideBackground: PropTypes.bool,
  isRound: PropTypes.bool
};

const defaultProps = {
  hideBackground: false,
  isRound: false
};

function DealerRater(props) {
  const { hideBackground, isRound, ...rest } = props;

  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...rest}>
      {!hideBackground && <rect fill="#E7561E" height="24" rx={isRound ? '100%' : 0} width="24" />}
      <path
        clipRule="evenodd"
        d="M11.4677 13.8546C11.7125 13.3756 11.8349 12.8062 11.8349 12.1464C11.8349 11.4368 11.7107 10.8408 11.4624 10.3583C11.214 9.87586 10.8876 9.49094 10.4832 9.20357C10.0788 8.91621 9.61756 8.71045 9.0996 8.58628C8.58163 8.46211 8.05658 8.40002 7.52443 8.40002H4.7998V15.9353H7.60957C8.12753 15.9353 8.6384 15.8626 9.14217 15.7171C9.64594 15.5717 10.0983 15.3446 10.4992 15.036C10.9 14.7273 11.2229 14.3335 11.4677 13.8546ZM9.73287 11.0874C9.87123 11.3677 9.94041 11.7207 9.94041 12.1464C9.94041 12.565 9.87123 12.9162 9.73287 13.2C9.59451 13.4839 9.41003 13.7109 9.17943 13.8812C8.94883 14.0515 8.68276 14.1739 8.3812 14.2484C8.07965 14.3229 7.76568 14.3601 7.43929 14.3601H6.57721V9.95391H7.48187C7.79406 9.95391 8.09739 9.98938 8.39185 10.0603C8.68631 10.1313 8.94883 10.2501 9.17943 10.4169C9.41003 10.5836 9.59451 10.8071 9.73287 11.0874ZM15.4429 12.9446L17.0713 15.9353H19.1999L17.2309 12.7105C17.7205 12.5615 18.1036 12.3131 18.3804 11.9654C18.6571 11.6178 18.7954 11.1885 18.7954 10.6776C18.7954 10.2448 18.7138 9.88296 18.5507 9.59205C18.3875 9.30113 18.1693 9.06699 17.8961 8.8896C17.6229 8.71222 17.3143 8.58628 16.9702 8.51178C16.626 8.43727 16.273 8.40002 15.9112 8.40002H13.0376V15.9353H14.8256V12.9446H15.4429ZM16.8848 10.2785C16.9593 10.3885 16.9965 10.5322 16.9965 10.7096C16.9965 10.9011 16.9558 11.0572 16.8742 11.1779C16.7926 11.2985 16.6879 11.3907 16.5602 11.4546C16.4325 11.5184 16.2906 11.5628 16.1345 11.5876C15.9784 11.6124 15.8258 11.6249 15.6768 11.6249H14.8147V9.86876H15.7832C15.9181 9.86876 16.0582 9.8794 16.2036 9.90069C16.3491 9.92198 16.4804 9.96277 16.5974 10.0231C16.7145 10.0834 16.8103 10.1685 16.8848 10.2785Z"
        fill="white"
        fillRule="evenodd"
      />
    </svg>
  );
}

DealerRater.propTypes = propTypes;
DealerRater.defaultProps = defaultProps;

export default DealerRater;
